export default "__VITE_ASSET__042b75fe__"